import React from "react";
import { ExternalLink, CheckCircle } from "lucide-react";
import reactCert from "../../images/namaste-react-cert.webp";
import nodeCert from "../../images/namaste-node-cert.webp";

const certificates = [
	{
		title: "React Certificate",
		image: reactCert,
		alt: "Namaste React Certificate",
		skills: [
			"React",
			"Redux Toolkit",
			"Component Lifecycle",
			"Performance Optimization",
			"React Hooks",
		],
		link: "https://namastedev.com/karanmundra97/certificates/namaste-react",
	},
	{
		title: "Node.js Certificate",
		image: nodeCert,
		alt: "Namaste Node Certificate",
		skills: [
			"Node.js",
			"Express.js",
			"MongoDB",
			"REST APIs",
			"Authentication & Security",
		],
		link: "https://namastedev.com/karanmundra97/certificates/namaste-node",
	},
];

const Certificate = () => {
	return (
		<div className="max-w-screen-md mx-auto px-4 sm:px-6 py-12">
			<div className="flex flex-col gap-10">
				{certificates.map((cert, index) => (
					<div
						key={index}
						className="flex flex-col items-center text-center bg-white p-6 shadow-lg rounded-xl w-full"
					>
						<h3 className="text-xl font-semibold mb-4">{cert.title}</h3>
						<img
							className="w-full max-w-[300px] sm:max-w-[400px] shadow-md rounded-lg mb-4"
							src={cert.image}
							alt={cert.alt}
							loading="lazy"
						/>

						{/* Skills Section */}
						<div className="text-lg font-medium mb-3">Skills Learnt</div>
						<div className="flex flex-wrap justify-center gap-3 text-gray-700 mb-5">
							{cert.skills.map((skill, i) => (
								<div
									key={i}
									className="flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-lg"
								>
									<CheckCircle className="w-4 h-4 text-green-600" />
									<span className="text-sm">{skill}</span>
								</div>
							))}
						</div>

						{/* View Certificate Button */}
						<a
							href={cert.link}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
						>
							View Certificate <ExternalLink className="w-5 h-5" />
						</a>
					</div>
				))}
			</div>
		</div>
	);
};

export default Certificate;
